import { render, staticRenderFns } from "./LinkModal.vue?vue&type=template&id=63176bf8"
import script from "./LinkModal.vue?vue&type=script&lang=ts"
export * from "./LinkModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports